<form>
  <div class="modal-header">
    <h4 class="modal-title">{{ pageTitle }}</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group">
      <label for="lotNumber">
        Lot Number (<small class="text-warning"
          >System will generate a unique lot number if this is empty.</small
        >)
      </label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="lotDetails.lotNumber"
        name="lotNumber"
        placeholder="System will generate a unique lot number if this is empty."
      />
    </div>

    <div class="form-group">
      <label for=""> Production Date </label>
      <input
        type="date"
        class="form-control"
        [(ngModel)]="lotDetails.productionDate"
        name="productionDate"
      />
    </div>

    <div class="form-group">
      <label for=""> Expiry Date </label>
      <input
        type="date"
        class="form-control"
        [(ngModel)]="lotDetails.expiryDate"
        name="expiryDate"
      />
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="activeModal.close('')"
      [disabled]="loading"
      [translate]="'BUTTONS.CLOSE'"
    >
      <i class="fas fa-times"></i> Close
    </button>
    <button (click)="onSubmit()" type="button" class="btn btn-primary">
      <i class="fas fa-check"></i> Create Lot
    </button>
  </div>
</form>
